
import { Vue, Component, Prop } from 'vue-property-decorator'
import Filelist from '@/components/media/Filelist.vue'
import Uploader from '@/components/media/Uploader.vue'
import axios from 'axios'
import Tenant, { tenantMediaFolders } from '@/types/tenant'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {
    Uploader,
    Filelist
  }
})

export default class TenantDocumentsTab extends Vue {
  @Prop({ type: Boolean, default: false }) editable!: boolean

  allowedMimeTypes = ['image/jpeg', 'image/png', 'application/pdf']
  maxFileSize = 16
  allowFileRename = this.editable

  activePanel:string = ls.get('tenantDocumentsPanel') || null
  directories = tenantMediaFolders

  newFileUploaded (file:File, key:string, important = false, concept = false) : void {
    const formData = new FormData()
    formData.append('position', key)
    formData.append('file', file)

    if (important) {
      formData.append('important', 'yes')
    }

    if (concept) {
      formData.append('concept', 'yes')
    }

    axios.post(process.env.VUE_APP_API_URL + '/tenants/' + this.currentItem.id + '/media', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => {
        this.$store.dispatch('updateTenant', res.data.data)
      })
  }

  refresh (): void {
    this.$store.dispatch('setCurrentTenant', this.currentItem.id)
  }

  setActivePanel (panel:string) : void {
    ls.set('tenantDocumentsPanel', panel)
    this.activePanel = panel
  }

  navigateTo (routeName:string, paramKey:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  get currentItem () : Tenant {
    return this.$store.getters.currentTenant
  }
}
